import m, {Vnode} from "mithril";
import {ImageItem} from "../../../../model/items/imageItem";
import Image from "../Image/Image";

export default class ImageRow {

    private readonly images: Image[];

    constructor(
        imageItems: ImageItem[]
    ) {
        this.images = imageItems.map(ii => new Image(ii));
    }

    public view(): Vnode {
        return m('.ImageRow', {}, this.images.map(i => m(i)));
    }
}